import React from 'react'
import { connect } from 'react-redux'
import FileUploader from '../../Containers/FileUploader'

import BannerActions from '../../Redux/BannerRedux'

class UpdateImage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        image_file: {
          web: props.detail.image_file.web,
          mobile: props.detail.image_file.mobile,
          original: props.detail.image_file.original
        },
        iso_code: props.detail.iso_code
      }
    }
  }

  _fileUploaded = (filename, field) => {
    let form = { ...this.state.form }
    form.image_file[field] = filename
    if (field === 'web') {
      form.image_file['original'] = filename
    }
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    const data = {
      id: this.props.detail.id,
      form: this.state.form
    }
    this.props.updateBanner(data)

    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Banner</h4>
        </div>

        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Banner Web (<span className='text-orange'>1049x433</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'banner' }} onUploaded={(filename) => this._fileUploaded(filename, 'web')} />
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Banner Mobile (<span className='text-orange'>335x320</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'banner' }} onUploaded={(filename) => this._fileUploaded(filename, 'mobile')} />
            </div>
          </div>
          <div className='form-group d-flex justify-content-end'>
            <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
            <button className='btn btn-lg btn-primary' type='submit'>Save</button>
          </div>
        </form>

      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  updateBanner: (data) => dispatch(BannerActions.bannerUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateImage)



// WEBPACK FOOTER //
// ./src/Containers/Banner/UpdateImage.js